<ng-container *ngIf="notification">
    <section class="notification">
        <div class="notification__content">
            <mat-icon class="notification__content-icon material-symbols-outlined">report</mat-icon>

            <div class="notification__content-text">
                <span class="notification__content-text--highlight">Warning - Trip ID {{ notification.trip }}</span>
                <span>
                    {{ notification.notificationDetail }}
                </span>
            </div>
        </div>

        <div class="notification__actions">
            <a
                mat-ripple
                class="btn-dark flex-center notification__actions-view"
                aria-label="View Service Request"
                (click)="onViewServiceRequest()"
            >
                View
            </a>
            <button *ngIf="!showSnoozeDropDown" mat-ripple class="btn-light" type="button" (click)="onShowDropDown()">
                <img alt="snooze" height="16" ngSrc="assets/icons/v2/clock-z.svg" width="18" />
            </button>
            <div *ngIf="showSnoozeDropDown" class="dropdown">
                <mat-select
                    class="control-dropdown time-range-dropdown"
                    aria-labelledby="title"
                    panelClass="select-v2-panel"
                    placeholder="Select time"
                    [(ngModel)]="snoozeTime"
                    (ngModelChange)="onSnoozeTimeChange($event.value)"
                >
                    <mat-option *ngFor="let time of snoozeTimeRange" [value]="time">
                        {{ time.label }}
                    </mat-option>
                </mat-select>
            </div>
            <button mat-ripple class="btn-light" (click)="closeNotification()">Dismiss</button>
        </div>
    </section>
</ng-container>
